export default "__VITE_ASSET__BC5CIwfL__"